import React, { Component } from 'react';
// import donorData from '../../test/donorData';
import { donorsIncluded } from '../../utils/donorHelpers';
import DonorName from './DonorName';
import _ from 'lodash';
import { connect } from 'react-redux';

class DonorSea extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentNames: [],
            preparedDonors: []
        };
        this._donorIndex = 0;
        this._donorsTotal = 0;
        this._ranks = null;
        this._init = true;
        this._namesDisplayed = 0;
        this._initbuffer = 0;
        this._allowRemove = true;
        this._removeQueue = [];
        this._gridPoints = [];
    }

    componentDidMount() {
        this.prepareDonors();
       // this.createDonorName();
        this._initTimeout = setTimeout(() => {
            this._init = false;
        }, this.props.config.initDuration);
        document.addEventListener("keydown", this.handleKeyDown);
        this._debugInterval = setInterval(() => {
            this.props.handleStats(this.state.currentNames.length, this._namesDisplayed)
        }, 1000)
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);
        clearTimeout(this._initTimeout);
        this._initTimeout = null;
        this._allowRemoveTimeout = null;
        clearInterval(this._debugInterval);
        this._debugInterval = null;
    }

    // shouldComponentUpdate(prevProps){

    // }

    componentDidUpdate(prevProps, prevState){
        if (this.props.contentStage===0){
            if (prevProps.contentStage===2){
                this.createDonorName();
            }
        }
        else if (this.props.contentStage===1){
            if (prevProps.contentStage===0){
                this._removeQueue = []; //clear remove queue
                //console.log("CLEARING REMOVE QUEUE")
            }
        }
    }

    handleKeyDown = (event) => {
        switch (event.key) {
            default:
                break;
        }
    }

    removeQueueAdd = (id) => {
        this._removeQueue.push(id);
    }

    allowRemoveRequest = (id) => {
        if (this._allowRemove===true){
            if (id===this._removeQueue[0]){ //only allow first item in queue to dequeue
                this._removeQueue.shift();
                this._allowRemove = false;
                clearTimeout(this._allowRemoveTimeout);
                this._allowRemoveTimeout = setTimeout(() => {
                    this._allowRemove = true;
                }, 500);
                return true;
            }
            else{
                return false;
            }
        }
        else{
            return false;
        }
    }

    prepareDonors = () => {

        let sortedCategories = donorsIncluded(this.props.donors.donorCategories, this.props.active_module_obj.contents.include_categories);
        let currentRank = this.props.config.ranks[0];

        //add rank to each donor so it can be referenced for sizing and duration
        _.forEach(sortedCategories, sc => {

            //back fill any missing rank configurations
            if (currentRank.rank !== sc.rank) {   //!_.find(ranks, {rank: sc.rank})
                if (_.find(this.props.config.ranks, { rank: sc.rank })) {

                    currentRank = _.find(this.props.config.ranks, { rank: sc.rank });
                }
            }
            _.forEach(sc.donors, donor => {
                donor.rank = sc.rank;
                donor.fontSize = currentRank.fontSize;
                donor.duration = currentRank.duration;
            })
        })

        let donorArray = [];

        _.forEach(sortedCategories, (category, key) => {
            category.donors = _.orderBy(category.donors, ['sorting_name'], ['asc']);
            //initialize array with the lowest level category
            if (key === 0) {
                donorArray = category.donors;
            }
            else {
                //distribute donors from category into full array
                donorArray = this.distributeArrayToArray(category.donors, donorArray);
            }
        });

        this._donors = donorArray;

    }

    distributeArrayToArray = (arrA, arrB) => {
        var comboLength = arrB.length + arrA.length
        var span = comboLength / arrA.length;

        for (var i = 0; i < arrA.length; i++) {
            arrB.splice(Math.floor(span * i), 0, arrA[i])
        }

        return arrB;
    }

    createDonorName = () => {

        if (this._donorIndex > this._donors.length - 1) {
            this._donorIndex = 0;
        }

        let donor = this._donors[this._donorIndex];
        let currentNames = this.state.currentNames;

        currentNames.push(
            {
                id: donor.id,
                name: donor.name,
                rank: donor.rank,
                duration: donor.duration,
                fontSize: this.props.height * donor.fontSize
            }
        );
        this._namesDisplayed++;
        this.setState({
            currentNames: currentNames,
        })
        this._donorIndex = this._donorIndex + 1;
        if (this._init === true) {
            this._initbuffer = this._initbuffer + this.props.config.cycleTime; //pad name fadeout
        }
    }

    releaseGridPoint = (id) => {
        // let gridPoints = this._gridPoints;
        let index = _.findIndex(this._gridPoints, { id: id });
        if (index > -1) {
            this._gridPoints.splice(index, 1);
        }
        else {
            //console.log("debug: grid point release failed.", id);
        }
     //   console.log("Grid Point Length", this._gridPoints.length)
        // this.setState({
        //     gridPoints: gridPoints
        // })
    }

    removeCurrentName = (id) => {
        let currentNames = this.state.currentNames;
        let index = _.findIndex(currentNames, { id: id });
        if (index > -1) {
            currentNames.splice(index, 1);
        }
        else {
            //console.log("debug: current name destroy failed.", index, id)
        }
        this.setState({
            currentNames: currentNames
        })
     //   console.log("Current Names: ", currentNames.length);
    }


    trySetGrid = (id, rect) => {
        let overlap = false;
        _.forEach(this._gridPoints, gp => {
            if (this.intersectRect(rect, gp.rect)) {
                overlap = true;
            }
        });
        if (overlap === true) {
            return { success: false, gridIndex: null };
        }
        //at this point the space is available
        // let gridPoints = this.state.gridPoints;
        this._gridPoints.push({ id: id, rect: rect });
        // this.setState({
        //     gridPoints: gridPoints
        // })
        return { success: true, gridIndex: this._gridPoints.length - 1 };
    }

    intersectRect = (r1, r2) => {
        return !(r2.left > r1.right ||
            r2.right < r1.left ||
            r2.top > r1.bottom ||
            r2.bottom < r1.top);
    }

    renderDonorNames = () => {
        return (
            this.state.currentNames.map(function (row, i) {
                return (
                    <DonorName
                        key={row.id}
                        id={row.id}
                        fontSize={row.fontSize}
                        trySetGrid={this.trySetGrid}
                        createDonorName={this.createDonorName}
                        height={this.props.height}
                        width={this.props.width}
                        name={row.name}
                        cycleTime={this._init === true ? this.props.config.cycleTimeInit : this.props.config.cycleTime}
                        fadeOutTime={this._init === true ? (row.duration * 1000) : row.duration * 1000}
                        edgeMargin={this.props.height * this.props.config.edgeMargin}
                        margin={this.props.config.nameMargin * this.props.height}
                        debug={this.debugCount}
                        releaseGridPoint={this.releaseGridPoint}
                        removeCurrentName={this.removeCurrentName}
                        rank={row.rank}
                        avoidBezel={true}
                        hScreens={this.props.screensH}
                        vScreens={this.props.screensV}
                        allowRemoveRequest={this.allowRemoveRequest}
                        removeQueueAdd={this.removeQueueAdd}
                        allowedScreens={this.props.allowedScreens}
                        forceFadeOut={this.props.contentStage===1? true : false}
                    />
                )
            }, this)
        )
    }

    render() {
        return (
            <div style={{ color: this.props.config.textColor, position: 'absolute', top: this.props.top, left: this.props.left, width: this.props.width, height: this.props.height }}>
                <div style={{ position: 'relative' }}>
                    {this.renderDonorNames()}
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state) => {
    const active_module_obj = state.content.dm_active[state.active_module];
    if (!active_module_obj){
        console.log("No active donor sea module found");
    }
    return {
        donors: state.donors,
        active_module: state.active_module,
        active_module_obj: active_module_obj
    };
};

export default connect(mapStateToProps, null)(DonorSea);



// WEBPACK FOOTER //
// ./src/Components/Donor/DonorSea.js